import { Component, Input } from '@angular/core';
import { getLabelsBadgeColor } from '../../labels.helpers';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'ed-document-label',
    templateUrl: './document-label.component.html',
    styleUrls: ['./document-label.component.scss'],
    standalone: true,
    imports: [CommonModule],
})
export class DocumentLabelComponent {
    public getLabelsBadgeColor = getLabelsBadgeColor;

    @Input()
    public label: string | undefined;

    @Input()
    public smallFont = false;
}
